import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IhmLinkModule } from '../ihm-link/ihm-link.module';
import { IhmSidenavComponent } from './ihm-sidenav.component';

@NgModule({
  imports: [CommonModule, RouterModule, MatTooltipModule, IhmLinkModule],
  declarations: [IhmSidenavComponent],
  exports: [IhmSidenavComponent]
})
export class IhmSidenavModule {}
